enum FormError {
    Unauthorized,
    UnexpectedError,
}

export default FormError;
